export default {"src":"/_next/static/media/iso-cert-1.b4e66068.svg","height":81,"width":130};